import axios, { AxiosRequestConfig } from 'axios';

export const logIn = (
    email: string,
    password: string,
    returnUrl: string,
    antiforgeryOptions: AxiosRequestConfig
) => {
    return axios.post('/api/auth/identity/account/v1/logIn', {
        userName: email,
        password: password,
        returnUrl: returnUrl
    }, antiforgeryOptions);
};

export const signUp = (
    email: string,
    password: string,
    terms: boolean,
    dateOfBirth: string,
    returnUrl: string,
    antiForgeryOptions: AxiosRequestConfig
) => {
    return axios.post('/api/auth/identity/account/v1/register', {
        email: email,
        password: password,
        termsAccepted: terms,
        birthDate: dateOfBirth,
        returnUrl
    }, antiForgeryOptions);
};

export const resetPassword = (
    email: string,
    antiForgeryOptions: AxiosRequestConfig
) => {
    return axios.post('/api/auth/identity/account/v1/resetpassword', {
        email: email
    }, antiForgeryOptions);
};

export const updatePassword = (
    resetCode: string,
    newPassword: string,
    antiForgeryOptions: AxiosRequestConfig
) => {
    return axios.post('/api/auth/identity/account/v1/updatepassword', {
        resetCode: resetCode,
        password: newPassword
    }, antiForgeryOptions);
};

export const validatePartner = (
    domain: string
) => {
    return axios.post('/api/auth/identity/external/v1/validatepartner', {
        pn: domain
    });
};

export const getError = (
    errorId: string
) => {
    return axios.get(`/api/auth/identity/account/v1/error?errorId=${errorId}`, {
        headers: { 'credentials': 'include' }
    });
};

export const signUpActivate = (
    code: string,
    antiForgeryOptions: AxiosRequestConfig
) => {
    return axios.post('/api/auth/identity/account/v1/activate', {
        ac: code
    }, antiForgeryOptions);
};

